// extracted by mini-css-extract-plugin
export default {"playerCont":"PlayerList-module__playerCont--KbBfM"};